<div class="referral-dialog" dir="rtl">

  <!-- Header -->
  <div class="referral-header">
    <h2 class="t-title-main">הפניה לבדיקות מעבדה</h2>
    <button class="close-btn" (click)="close()" matTooltip="סגור">
      <span class="close-x" aria-hidden="true">✕</span>
    </button>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="loading-bar">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>

  <!-- Patient Details -->
  <div class="patient-strip">
    <div class="patient-field"><span class="patient-label">שם המטופל/ת</span><span class="patient-val">{{ data.patientName }}</span></div>
    <div class="patient-field"><span class="patient-label">ת.ז.</span><span class="patient-val">{{ data.patientID }}</span></div>
    <div class="patient-field"><span class="patient-label">תאריך לידה</span><span class="patient-val">{{ data.patientDOB | date:'dd/MM/yyyy' }}</span></div>
    <div class="patient-field" *ngIf="data.HMO"><span class="patient-label">קופה</span><span class="patient-val">{{ getHMO(data.HMO) }}</span></div>
    <div class="patient-field" *ngIf="createdAt"><span class="patient-label">תאריך יצירה</span><span class="patient-val">{{ createdAt | date:'dd/MM/yyyy' }}</span></div>
  </div>

  <!-- Error -->
  <div class="error-msg" *ngIf="errorMsg">{{ errorMsg }}</div>

  <!-- Selection summary -->
  <div class="selection-summary">נבחרו {{ selectedCount }} בדיקות</div>

  <!-- Categorized checkbox groups -->
  <div class="categories-grid">
    <div class="category-card" *ngFor="let cat of categories; let ci = index" [class.open]="isExpanded(ci)">
      <div class="category-head" (click)="toggleExpand(ci)" [class.disabled]="isLocked()">
        <span class="cat-check"
              [class.checked]="isGroupAll(ci)"
              [class.indeterminate]="isGroupSome(ci)"
              role="checkbox" [attr.aria-checked]="isGroupAll(ci)"
              (click)="$event.stopPropagation(); toggleGroup(ci)"></span>
        <span class="cat-name">{{ cat.name }}</span>
        <span class="cat-count" *ngIf="groupSelectedCount(ci) > 0">{{ groupSelectedCount(ci) }}</span>
        <span class="cat-arrow" [class.up]="isExpanded(ci)" aria-hidden="true"></span>
      </div>
      <ul class="test-list" *ngIf="isExpanded(ci)">
        <li class="test-row" *ngFor="let t of cat.tests; let ti = index"
            (click)="toggleTest(ci, ti)"
            [class.selected]="isSelected(ci, ti)"
            [class.disabled]="isLocked()">
          <span class="test-check" [class.checked]="isSelected(ci, ti)"></span>
          <span class="test-name">{{ t.name }}</span>
          <span class="test-code" *ngIf="t.code">{{ t.code }}</span>
        </li>
      </ul>
    </div>
  </div>

  <!-- Instructions -->
  <div class="instructions-section">
    <label class="field-label">הוראות</label>
    <textarea class="t-input instructions-textarea" rows="3" [formControl]="instructionsCtrl"
      placeholder="הוראות לרופא/למעבדה (אופציונלי)"
      [readonly]="isLocked()"></textarea>
  </div>

  <!-- Actions -->
  <div class="action-row">
    <button class="btn-primary" (click)="sign()"
      [disabled]="selectedCount === 0 || signing"
      *ngIf="!isSigned() || editing">
      {{ signing ? 'חותם...' : (editing ? 'חתום מחדש' : 'חתום ושמור') }}
    </button>

    <button class="btn-primary btn-edit" (click)="startEdit()"
      *ngIf="isSigned() && !editing">
      עריכה
    </button>

    <span class="signed-info" *ngIf="isSigned() && !editing">
      נחתם ע"י {{ signerTitle ? signerTitle + ' ' : '' }}{{ signerName }} ב-{{ signedAt | date:'dd/MM/yyyy' }}
    </span>

    <!-- Print defaults to Hebrew and prints directly. To restore language selection, use (click)="openPrint()". -->
    <button class="btn-print-icon" (click)="print('he')"
      *ngIf="isSigned() && !editing"
      matTooltip="הדפס הפניה">
      <img src="assets/icons/print.svg" alt="הדפס" style="height:1.4em;" onerror="style.display='none'" />
      <span>הדפס</span>
    </button>

    <span class="action-spacer"></span>
    <button class="btn-delete" (click)="askDelete()" *ngIf="referralId" matTooltip="מחק הפניה">מחק</button>
  </div>

  <!-- Delete confirmation overlay -->
  <div class="delete-confirm-overlay" *ngIf="confirmingDelete">
    <div class="delete-confirm-box">
      <h3>מחיקת הפניה לבדיקות מעבדה</h3>
      <p>האם למחוק את ההפניה לבדיקות מעבדה?</p>
      <div class="delete-confirm-actions">
        <button class="btn-delete" (click)="confirmDelete()" [disabled]="deleting">{{ deleting ? 'מוחק...' : 'מחק' }}</button>
        <button class="btn-primary" (click)="cancelDelete()" [disabled]="deleting">ביטול</button>
      </div>
    </div>
  </div>

</div>
